import { isPurchasedOnlyFlag } from '../../Components/Gen1/Application/gen1MasterItemHelpers';

export default class {
    constructor(dataObject = null) {
        this.Id = 0;
        this.ModelName = '';
        this.IsPurchasedOnly = false;

        // Import data if set
        if (dataObject) {
            try {
                this.Id = dataObject.id;
                this.ModelName = dataObject.ModelName;
                this.IsPurchasedOnly = isPurchasedOnlyFlag(
                    dataObject.IsPurchasedOnly
                );
            } catch (e) {
                throw 'Data import error @ ModelMasterForGen1 data.';
            }
        }
    }
}
